/**
 * Copyright IBM Corp. 2022, 2022
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */
import { px } from '@carbon/layout';
export var getSpreadsheetWidth = function getSpreadsheetWidth(_ref) {
  var type = _ref.type,
      headerGroup = _ref.headerGroup,
      scrollBarSizeValue = _ref.scrollBarSizeValue,
      totalVisibleColumns = _ref.totalVisibleColumns,
      defaultColumn = _ref.defaultColumn,
      totalColumnsWidth = _ref.totalColumnsWidth,
      visibleColumns = _ref.visibleColumns;
  var additionalWidth = scrollBarSizeValue + defaultColumn.rowHeaderWidth;

  if (!totalVisibleColumns) {
    if (type === 'header') {
      return px(parseInt(headerGroup.getHeaderGroupProps().style.width) + additionalWidth);
    }

    if (type !== 'header') {
      return totalColumnsWidth + additionalWidth;
    }
  }

  if (totalVisibleColumns) {
    var totalVisibleColumnWidth = visibleColumns.map(function (item, index) {
      return index <= totalVisibleColumns - 1 && ((item === null || item === void 0 ? void 0 : item.width) || (defaultColumn === null || defaultColumn === void 0 ? void 0 : defaultColumn.width));
    }).reduce(function (prev, curr) {
      return prev + curr;
    }, 0);
    return totalVisibleColumnWidth + additionalWidth;
  }
};